<mat-card>
  <mat-card-header>
    <mat-card-title class="text-primary">{{ 'agent.contact_person' | translate }}</mat-card-title>
  </mat-card-header>
  <mat-card-content>
    <div class="my-2 flex items-center">
      <div class="flex justify-center items-center">
        <img *ngIf="agent?.picture else noAgentImage" class="agent-image mr-4" [src]="agent?.picture"
          alt="Maklerbild" />
        <ng-template #noAgentImage>
          <mat-icon class="mr-2 !w-10 !h-10 text-4xl text-gray-medium" fontIcon="account_circle"></mat-icon>
        </ng-template>
      </div>
      <div *ngIf="agent?.themeConfig !== 'sulek'">
        <p class="text-md font-semibold text-primary">
          {{agent?.firstName}} {{agent?.lastName}}
        </p>
        <p class="text-sm text-gray-medium" *ngIf="agent?.legalEntity">
          {{agent?.legalEntity}}
        </p>
        <p class="text-sm text-secondary" *ngIf="agent?.officeName">
          {{agent?.officeName}}
        </p>
      </div>
        <div *ngIf="agent?.themeConfig === 'sulek'">
            <p class="text-md font-semibold text-primary">
                {{property?.agent?.firstName ?? agent?.firstName}} {{property?.agent?.lastName ?? agent?.lastName}}
            </p>
            <p class="text-sm text-gray-medium" *ngIf="agent?.legalEntity">
                {{agent?.legalEntity}}
            </p>
            <p class="text-sm text-secondary" *ngIf="agent?.officeName">
                {{agent?.officeName}}
            </p>
        </div>
    </div>
    <div class="flex space-x-2" *ngIf="agent?.themeConfig !== 'sulek'">
      <a class="mt-2" mat-flat-button color="primary" href="mailto:{{agent?.email}}" target="_blank">{{ 'agent.email' | translate }}</a>
      <a *ngIf="agent?.phone" class="mt-2" mat-flat-button color="primary" href="tel:{{agent?.phone}}" target="_blank">{{ 'agent.call' | translate }}</a>
    </div>
      <div class="flex space-x-2" *ngIf="agent?.themeConfig === 'sulek'">
          <a class="mt-2" mat-flat-button color="primary" href="mailto:{{property?.agent?.email}}" target="_blank">{{ 'agent.email' | translate }}</a>
          <a *ngIf="property?.agent?.phone" class="mt-2" mat-flat-button color="primary" href="tel:{{property?.agent?.phone}}" target="_blank">{{ 'agent.call' | translate }}</a>
      </div>
  </mat-card-content>
</mat-card>